import { RoutePaths } from "./constants";
import { DataModel } from "./models/data.model";

const parameter = "v1";

export function getSharedLinkUrl(dataModel: DataModel): URL {
  const url = window.location.href;

  let link = new URL(url);
  link.pathname = (process.env.PUBLIC_URL ?? "") + RoutePaths.landing;
  link.searchParams.set(parameter, btoa(JSON.stringify(dataModel)));

  return link;
}

export function extractParamsFromUrl(
  searchParams: URLSearchParams
): DataModel | undefined {
  const value = searchParams.get(parameter);
  if (!value) return;
  try {
    const result = JSON.parse(atob(value));
    searchParams.delete(parameter);
    return result;
  } catch (e) {}
}
